import * as React from 'react'

import { MobXProviderContext } from 'mobx-react'

import { FilterButton } from '~/client/src/shared/components/Filters/triggers'
import Localization from '~/client/src/shared/localization/LocalizationManager'

type IProps = Omit<
  React.ComponentProps<typeof FilterButton>,
  'label' | 'iconOnly' | 'size'
>

// Square like Display while nothing is applied; the padded size lets the count
// badge sit beside the icon.
export const ListHeaderFilterButton = React.forwardRef<
  HTMLButtonElement,
  IProps
>(function ListHeaderFilterButton({ badgeCount, ...props }, ref) {
  const { isMobileEnv } = React.useContext(MobXProviderContext) as {
    isMobileEnv?: boolean
  }
  const hasCount = !!badgeCount && badgeCount > 0

  return (
    <FilterButton
      ref={ref}
      label={Localization.translator.filter}
      badgeCount={badgeCount}
      iconOnly
      size={
        hasCount
          ? isMobileEnv
            ? 'lg'
            : 'default'
          : isMobileEnv
            ? 'icon-lg'
            : 'icon'
      }
      {...props}
    />
  )
})
